// extracted by mini-css-extract-plugin
export default {"container":"style_container__faAhp","btn":"style_btn__9LyA6","icon":"style_icon__xWbZq","name":"style_name__DYeX+","suffix":"style_suffix__wbBg5"};